// Map namespace - the unified map-based app engine
import Canvas from "./Canvas";
import Panel from "./layout/Panel";
import { HeaderLeft, HeaderRight } from "./layout/Header";
import Controls from "./layout/Controls";
import Messages from "./layout/Messages";

export const Map = {
  Canvas,
  Panel,
  HeaderLeft,
  HeaderRight,
  Controls,
  Messages,
};

// Viewport hook (engine-agnostic)
export { useViewport } from "./viewport/useViewport";

// Layout hooks
export { usePanel, usePanelPosition, type PanelPosition } from "./layout/useMapLayout";

// Legacy: NomaMap (will be removed after migration)
export { NomaMap } from "./_legacy/NomaMap";

// Layers
export { PlacesLayer } from "./layers/PlacesLayer";
export { AdventureMapPlacesLayer } from "./layers/AdventureMapPlacesLayer";
export { SelectedPlaceLayer } from "./layers/SelectedPlaceLayer";
export { RelatedPlacesLayer } from "./layers/RelatedPlacesLayer";
export { RouteTrackLayer } from "./layers/RouteTrackLayer";
export { MapboxPoiLayer } from "./layers/MapboxPoiLayer";
export { MapboxTrailsLayer, type TrailClickEvent } from "./layers/MapboxTrailsLayer";

// Low-level hooks
export { useMapEvent } from "./hooks/useMapEvent";
export { useCursorOnHover } from "./hooks/useCursorOnHover";

// UI Components
export { ControlGroup } from "./controls/ControlGroup";
export { CompassControl } from "./controls/CompassControl";
export { ZoomControls } from "./controls/ZoomControls";

// Primitives
export { MapMarker } from "./primitives/MapMarker";
export { MapPopup } from "./primitives/MapPopup";

// Test utilities
export { MapTestProvider } from "./MapTestProvider";
